import { useLocation } from 'react-router'

// Components
import Wrapper from 'components/filter/wrapper'
import Filters from 'components/filter/filters'

// Types
import { QueryObject } from 'types'

type SortModes = Array<{ value: number; name: string }>

type FilterProps = {
  filterInputPlaceholder: string
  hideDisplayMode?: boolean
  sortModes: SortModes
  selectedFilters: Array<string>
  queryObj?: QueryObject
}

const Filter = ({ filterInputPlaceholder, hideDisplayMode, sortModes, selectedFilters, queryObj }: FilterProps): JSX.Element => {
  return (
    <Wrapper
      filterInputPlaceholder={filterInputPlaceholder}
      hideDisplayMode={hideDisplayMode}
      sortModes={sortModes}
      selectedFilters={selectedFilters}
    >
      {toggleMobileFilterVisible => (
        <Filters
          toggleMobileFilterVisible={toggleMobileFilterVisible}
          sortModes={sortModes}
          selectedFilters={selectedFilters}
          queryObj={queryObj}
        />
      )}
    </Wrapper>
  )
}

const purchaseDate = { value: 1, name: 'Purchase date' }
const popularity = { value: 1, name: 'Popularity' }
const whatsNew = { value: 2, name: "What's new" }
const alphabetical = { value: 3, name: 'Alphabetical A-Z' }
const alphabeticalReverse = { value: 4, name: 'Alphabetical Z-A' }
const releaseYear = { value: 5, name: 'Release year' }

/*
TRACKS
*/
export const tracksSortModes = [popularity, whatsNew, alphabetical, alphabeticalReverse, releaseYear]
const TrackFilter = ({ queryObj }: { queryObj?: QueryObject }) => {
  const { pathname } = useLocation()
  const noSorting = pathname.startsWith('/collection/')
  let sortModes = tracksSortModes
  if (pathname.startsWith('/purchasedtracks')) {
    sortModes = [purchaseDate, alphabetical, alphabeticalReverse, releaseYear]
  } else if (pathname.startsWith('/favorites')) {
    sortModes = [alphabetical, alphabeticalReverse, releaseYear, whatsNew]
  } else if (noSorting) {
    sortModes = []
  }
  const trackFilters = ['genres', 'keys', 'types', 'bpm', 'release_year', 'regions', 'categories']
  return <Filter filterInputPlaceholder="Filter tracks" sortModes={sortModes} selectedFilters={trackFilters} queryObj={queryObj} />
}

export default TrackFilter

/*
ARTISTS
*/
const artistsSortModes: SortModes = [] // NOTE(Kitti): tempo remove these until it works in BE [alphabetical, alphabeticalReverse]
const artistsFilters = ['genres', 'release_year'] // ['release_year', 'regions']
export const ArtistsFilter = () => {
  return <Filter filterInputPlaceholder="Filter artists" hideDisplayMode sortModes={artistsSortModes} selectedFilters={artistsFilters} />
}

/*
COLLECTIONS
*/
export const CollectionsFilter = () => {
  return <Filter filterInputPlaceholder="Search collections…" hideDisplayMode sortModes={[]} selectedFilters={[]} />
}

/*
SONG
*/
export const SongFilter = () => {
  return <Filter filterInputPlaceholder="Search tracks" sortModes={[]} selectedFilters={[]} />
}

/*
LABELS
*/
export const LabelsFilter = () => {
  return <Filter filterInputPlaceholder="Search labels" hideDisplayMode sortModes={[]} selectedFilters={[]} />
}
